/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import IButton from '../../../components/Common/iComponents/iButton/IButton';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import * as url from '../../../helpers/url_helper';

import { useDispatch, useSelector } from 'react-redux';
import { sendTestEmail } from '../../../store/actions';

// App "Innobo Hub" en Microsoft Entra ID (multi-tenant + cuentas personales). El ID es publico;
// el secreto vive solo en el backend (App Settings MS_CLIENT_SECRET).
const MS_CLIENT_ID = '99cf57c4-2bab-4b2f-a1da-584f7dc0d3ae';
const MS_SCOPES = [
    'openid',
    'email',
    'profile',
    'offline_access',
    'https://graph.microsoft.com/Mail.Send',
    'https://graph.microsoft.com/User.Read',
];

const OauthMicrosoft = ({ onUpdateClient, form, setForm }: any) => {
    const dispatch = useDispatch();
    const path = url.API_URL;

    const testEmailRedux = useSelector((state: any) => state.clients?.brandCustom?.email);
    const { isLoading, errorTestEmail, messageTestEmail } = useSelector((state: any) => state.clients);

    const [isTestEmail, setIsTestEmail] = useState(false);
    const [testEmail, setTestEmail] = useState("");

    const conectado = Boolean(form.smtpEmail && form.refreshTokenGoogle && form.nameUserGoogle);

    useEffect(() => {
        setTestEmail(testEmailRedux);
    }, [testEmailRedux]);

    useEffect(() => {
        const handleTokenMessage = (event: any) => {
            const baseUrl = `${window.location.origin}`;
            if (event.origin !== baseUrl) return;
            const { token, name: nameUserGoogle, email: smtpEmail } = event.data;
            if (token) {
                // Se reutilizan las columnas de Google (refreshTokenGoogle, nameUserGoogle): emailType dice cual es
                const newObject = { ...form, emailType: 'Microsoft', refreshTokenGoogle: token, nameUserGoogle, photoUserGoogle: '', smtpEmail };
                setForm(newObject);
                onUpdateClient(newObject);
            }
        };
        window.addEventListener("message", handleTokenMessage);
        return () => {
            window.removeEventListener("message", handleTokenMessage);
        };
    }, [form]);

    useEffect(() => {
        if (errorTestEmail && messageTestEmail && isTestEmail) {
            Swal.fire({
                icon: errorTestEmail ? "success" : 'error',
                title: 'Send test Email',
                text: messageTestEmail,
                showConfirmButton: true,
            });
            setIsTestEmail(false);
        }
    }, [isLoading]);

    const openPopup = () => {
        const width = 600;
        const height = 800;
        const screenX = window.screenX !== undefined ? window.screenX : window.screenLeft;
        const screenY = window.screenY !== undefined ? window.screenY : window.screenTop;
        const outerWidth = window.outerWidth !== undefined ? window.outerWidth : document.documentElement.clientWidth;
        const outerHeight = window.outerHeight !== undefined ? window.outerHeight : document.documentElement.clientHeight;
        const left = Math.floor((outerWidth - width) / 2) + screenX;
        const top = Math.floor((outerHeight - height) / 2) + screenY;

        const baseUrl = `${window.location.origin}`;
        // Solo la pagina de vuelta: el secreto no viaja por el navegador
        const state = btoa(JSON.stringify({ url: baseUrl + "/OauthCallBack" }));
        const redirectUri = (path.endsWith('api') ? path.slice(0, -3) : path) + "oauth2callback/microsoft";

        const params = new URLSearchParams({
            client_id: MS_CLIENT_ID,
            response_type: 'code',
            redirect_uri: redirectUri,
            response_mode: 'query',
            scope: MS_SCOPES.join(' '),
            state,
            prompt: 'select_account',
        });

        return window.open(
            `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params.toString()}`,
            "popupWindow",
            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
        );
    };

    const handleDeleteEmail = () => {
        const newObject = { ...form, refreshTokenGoogle: "", nameUserGoogle: "", photoUserGoogle: "", smtpEmail: "" };
        setForm(newObject);
        onUpdateClient(newObject);
    };

    return (
        <>
            <div style={{ width: "60%" }}>
                <div className='d-flex justify-content-center align-items-center'>
                    <div className='row cardGoogle cursor-pointer'>
                        {conectado ?
                            <>
                                <div className='col-2 justify-content-center align-items-center d-flex'>
                                    <i className='bx bxl-microsoft fs-1'></i>
                                </div>
                                <div className='col-8'>
                                    <h2 className='nameGoogle'>{form.nameUserGoogle}</h2>
                                    <p className='emailGoogle'>{form.smtpEmail}</p>
                                </div>
                                <div className='col-2 justify-content-center align-items-center d-flex'>
                                    <IButton
                                        className="btn-delete"
                                        label={''}
                                        btnIcon="bx bx-x"
                                        actionOnClick={handleDeleteEmail}
                                    ></IButton>
                                </div>
                            </>
                            :
                            <div className='row justify-content-center align-items-center d-flex' onClick={openPopup}>
                                <div className='col-2 justify-content-center align-items-center d-flex'>
                                    <i className='bx bxl-microsoft fs-1'></i>
                                </div>
                                <div className='col-8'>
                                    <h2 className='nameGoogle'>Login with Microsoft</h2>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div className={`user-card ${conectado ? "fade-in" : "fade-out"}`}>
                    <div className='row  ps-5'>
                        <div className='col-9'>
                            <IInput
                                title={"Email address for sending the test"}
                                value={testEmail}
                                type={'text'}
                                onInputHandler={(e: any) => setTestEmail(e.target.value)}
                            />
                        </div>
                        <div className='col-3'>
                            <IButton
                                className="btn-base m-2"
                                label={'Send Email'}
                                btnIcon="bx bx-send"
                                actionOnClick={() => {
                                    setIsTestEmail(true);
                                    dispatch(sendTestEmail(testEmail));
                                }}
                            ></IButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

OauthMicrosoft.propTypes = {
    onUpdateClient: PropTypes.func,
    form: PropTypes.object,
    setForm: PropTypes.func
};
export default OauthMicrosoft;
